__turbopack_context__.v({
  "brand-seal": "index-module-scss-module___BFH4W__brand-seal",
  "check-icon": "index-module-scss-module___BFH4W__check-icon",
  "quality-seal": "index-module-scss-module___BFH4W__quality-seal",
  "quality-seal-caption": "index-module-scss-module___BFH4W__quality-seal-caption",
  "quality-seal-caption-text": "index-module-scss-module___BFH4W__quality-seal-caption-text",
  "quality-seal-heading": "index-module-scss-module___BFH4W__quality-seal-heading",
  "quality-seal-name": "index-module-scss-module___BFH4W__quality-seal-name",
});
